// src/travel-guides/adminTravelGuidesApi.ts
import { apiClient } from "@maat/api-base";
var BASE = "/main/api/admin/travel-guides";
var adminTravelGuidesApi = {
  listModeration: (params) => apiClient.get(`${BASE}/moderation`, { params }),
  getModeration: (guideId) => apiClient.get(`${BASE}/${guideId}`),
  approve: (guideId, reason) => apiClient.post(`${BASE}/${guideId}/approve`, { reason }),
  reject: (guideId, reason) => apiClient.post(`${BASE}/${guideId}/reject`, { reason }),
  reRun: (guideId) => apiClient.post(`${BASE}/${guideId}/re-run`),
  draftFeedback: (guideId) => apiClient.get(`${BASE}/${guideId}/feedback-draft`)
};

export {
  adminTravelGuidesApi
};
